var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3034_891",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 71L71 1.63387e-05L142 71L71 142L0 71Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71L71 1.63387e-05L142 71L71 142L0 71Z",
    fill: "url(#paint0_linear_3034_891)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_3034_891_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_3034_891)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.071 -0.071 0 71 71)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1029.88,
    y: -1029.88,
    width: 2059.76,
    height: 2059.76
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 0.5) 0deg,rgba(255, 255, 255, 0.05) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71L-1.06066 69.9393L-2.12132 71L-1.06066 72.0607L0 71ZM71 1.63387e-05L72.0606 -1.06064L71 -2.1213L69.9393 -1.06064L71 1.63387e-05ZM142 71L143.061 72.0607L144.121 71L143.061 69.9393L142 71ZM71 142L69.9393 143.061L71 144.121L72.0606 143.061L71 142ZM0 71L1.06066 72.0607L72.0606 1.06068L71 1.63387e-05L69.9393 -1.06064L-1.06066 69.9393L0 71ZM71 1.63387e-05L69.9393 1.06068L140.939 72.0607L142 71L143.061 69.9393L72.0606 -1.06064L71 1.63387e-05ZM142 71L140.939 69.9393L69.9393 140.939L71 142L72.0606 143.061L143.061 72.0607L142 71ZM71 142L72.0606 140.939L1.06066 69.9393L0 71L-1.06066 72.0607L69.9393 143.061L71 142Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.50},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.050000000745058060},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":0.0,\"m01\":-141.99993896484375,\"m02\":141.99995422363281,\"m10\":141.99993896484375,\"m11\":0.0,\"m12\":3.7498324672924355e-05},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_3034_891)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_3034_891_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 71L-1.06066 69.9393L-2.12132 71L-1.06066 72.0607L0 71ZM71 1.63387e-05L72.0606 -1.06064L71 -2.1213L69.9393 -1.06064L71 1.63387e-05ZM142 71L143.061 72.0607L144.121 71L143.061 69.9393L142 71ZM71 142L69.9393 143.061L71 144.121L72.0606 143.061L71 142ZM0 71L1.06066 72.0607L72.0606 1.06068L71 1.63387e-05L69.9393 -1.06064L-1.06066 69.9393L0 71ZM71 1.63387e-05L69.9393 1.06068L140.939 72.0607L142 71L143.061 69.9393L72.0606 -1.06064L71 1.63387e-05ZM142 71L140.939 69.9393L69.9393 140.939L71 142L72.0606 143.061L143.061 72.0607L142 71ZM71 142L72.0606 140.939L1.06066 69.9393L0 71L-1.06066 72.0607L69.9393 143.061L71 142Z",
    mask: "url(#path-1-inside-1_3034_891)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3034_891",
    x1: 142,
    y1: 225.5,
    x2: 24.9255,
    y2: 23.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/Rectangle.f274df0bd8de3913e04c3aa2e3a57c5b.svg";
export { ForwardRef as ReactComponent };